export default __webpack_public_path__ + "static/media/52-min.681f768f.png";